export const errorMessages = {
  fetchDataFailed:
    "An error occurred while fetching data. Please try again later!",
  invalidInput: "Please provide valid input!",
  unauthorizedAccess:
    "You are not authorized to perform this action. Please contact the admin!!!",
  noTokenFound: "No token found, you have to login again!",
  invalidToken: "Either the token is wrong or has expired, Please login again!",
  noInternet: "No Network, Please check your connectivit!",
  serverError:
    "The server is facing some issues, please hang tight while we are fixing it!!!",
  unauthorizedProjectAccess: "You are not authorized to perform this action!",
  formdataWithFilesFailed: "Syncing with backend failed, please try again!!",
  invalidCredentials: "Email/Password is wrong. Try again!!",
};
